import { Commande } from 'src/app/models/Commande';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'commande'
})

export class CommandePipe implements PipeTransform {
  badgeMap = {
    TRESORERIE: 'badge-warning',
    TRESORERIE_OMY: 'badge-warning',
    ADV: 'badge-danger',
    SUPPORT_DD: 'badge-success',
    COMPTA: 'badge-success',
    MAGASIN_AGENT: 'badge-success',
    ELSE: 'badge-info'
  }
  etatMap = {
    ENCOURS: 'badge-warning',
    VALIDE: 'badge-success',
    REJET: 'badge-danger',
    ELSE: 'badge-info'
  }

  logoMap = {'NAFAMA': '/assets/dist/img/nafama_logo.svg', 'Produits': '/assets/dist/img/produitc_logo.svg', 'Orange Money': '/assets/dist/img/orange_money.svg', 'ELSE': '/assets/dist/img/orange_money.svg'};
  transform(commande: Commande, extract: 'logo' | 'badge' | 'etat'): any {
    if(extract === 'logo') {
      return this.logoMap[commande.typeCommande] || this.logoMap.ELSE;
    }
    if(extract === 'badge') {
      return this.badgeMap[commande.etat] || this.badgeMap.ELSE;
    }
    return this.etatMap[commande.etatLivraison] || this.etatMap.ELSE;
  }
}